import Alpine from "alpinejs";

Alpine.data('Marquee', () => ({
    speed: 30,
    duration: 0,
    animateMarquee: true,
    init(){
        this.update();
    },
    update(){
        let totalWidth = this.$refs.scroller.scrollWidth;
        let groupWidth = this.$refs.itemGroup.offsetWidth;
        
        if(groupWidth < window.innerWidth){
            this.animateMarquee = false;
        } else {
            this.animateMarquee = true;
        }

        let distance = totalWidth / 2;
        this.duration = distance / this.speed;
    }
}));